import React from 'react';

export interface RankedBarItem {
  label: string;
  value: number;
  displayValue: string;
}

interface Props {
  items: RankedBarItem[];
  barColor: string;
}

const RankedBarList: React.FC<Props> = ({ items, barColor }) => {
  const maxValue = items.reduce((acc, item) => Math.max(acc, item.value), 0);

  return (
    <div className="ranked-bar-list">
      {items.map((item, idx) => {
        const widthPct = maxValue > 0 ? (item.value / maxValue) * 100 : 0;
        return (
          <div className="ranked-bar-row" key={`${item.label}-${idx}`}>
            <span className="ranked-bar-label" title={item.label}>
              {item.label}
            </span>
            <span className="ranked-bar-track">
              <span className="ranked-bar-fill" style={{ width: `${widthPct}%`, backgroundColor: barColor }} />
            </span>
            <span className="ranked-bar-value">{item.displayValue}</span>
          </div>
        );
      })}
    </div>
  );
};

export default RankedBarList;
